import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n';

if (typeof window !== "undefined") {
  let shown = false;
  const showMessage = () => {
    if (!shown) {
      console.log("%c🖕", "font-size: 64px; color: red;");
      console.log("Babayı görürsün xD");
      shown = true;
    }
  };
  // Konsol açıldığını algılamak için
  const element = new Image();
  Object.defineProperty(element, 'id', {
    get: function () {
      showMessage();
    }
  });
  console.log(element);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

